import { type UIConfig } from '../../../types';
import {
	SPLIT_LAYOUT_ADJACENT_MIN_WIDTH,
	SPLIT_LAYOUT_INITIAL_WIDTH,
	SPLIT_LAYOUT_MIN_WIDTH,
} from '../../constants/private';

export const initialState: UIConfig = {
	fullScreen: false,
	externalEmbed: false,
	isSplitLayout: false,
	splitLayoutInitialWidth: SPLIT_LAYOUT_INITIAL_WIDTH,
	splitLayoutMinWidth: SPLIT_LAYOUT_MIN_WIDTH,
	splitLayoutAdjacentMinWidth: SPLIT_LAYOUT_ADJACENT_MIN_WIDTH,
	splitLayoutStorageKey: 'conversation-assistant.split-layout.right-width',
	customHandlers: {
		handleDeepLinkClick: undefined,
		handleSubmitSmartCreate: () => {},
	},
	isBitbucketBetaEnabled: false,
	customFeedbackCategories: undefined,
	stagingAreaRef: undefined,
	promptInputDroppableUrls: undefined,
	enableBrowserContextBanner: false,
	disableSettingsModal: false,
	enableSkills: true,
	browserContextSanitizer: undefined,
	elements: {
		closeButton: true,
		newChatButton: true,
		fullscreenButton: true,
		createAgentButton: true,
		browseAgentsButton: true,
		agentsMenu: true,
		navbar: true,
		mainChatHeader: true,
		stagingAreaEnabled: false,
		voiceDictationButton: false,
		fileUploadButton: true,
		chatModeMenuButton: true,
		shouldShowConversationActions: true,
		shouldShowContextBanner: true,
	},
};
